// ===== THEME (Fase 2: Claro / Escuro / Sistema) =====
// 'tema_preferencia' guarda a escolha do usuário (light|dark|system);
// 'tema' continua guardando o tema RESOLVIDO (light|dark), por compatibilidade
// com código legado que lia essa chave diretamente.
function resolverTemaPreferencia(pref){
  if(pref==='system')return(window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches)?'dark':'light';
  return pref==='dark'?'dark':'light';
}
function temaPreferenciaAtual(){
  return localStorage.getItem('tema_preferencia')||localStorage.getItem('tema')||'system';
}
function temaInicialGaturamo(){
  if(localStorage.getItem('temaDesignVersion')!=='v175'){
    if(!localStorage.getItem('tema_preferencia'))localStorage.setItem('tema_preferencia','light');
    localStorage.setItem('temaDesignVersion','v175');
  }
  return resolverTemaPreferencia(temaPreferenciaAtual());
}
function atualizarUiTema(){
  const pref=temaPreferenciaAtual(),resolved=document.documentElement.getAttribute('data-theme');
  const icon=document.getElementById('theme-btn-icon');
  if(icon)icon.className=pref==='system'?'ti ti-device-desktop':(resolved==='dark'?'ti ti-moon':'ti ti-sun');
  const btn=document.getElementById('theme-btn');
  if(btn)btn.setAttribute('aria-label',`Tema: ${pref==='system'?'Sistema':pref==='dark'?'Escuro':'Claro'}`);
  document.querySelectorAll('.theme-menu-item').forEach(b=>b.setAttribute('aria-checked',String(b.dataset.pref===pref)));
  renderTemaMenuConta();
}
function aplicarTemaResolvido(){
  document.documentElement.setAttribute('data-theme',resolverTemaPreferencia(temaPreferenciaAtual()));
  atualizarUiTema();
}
function definirPreferenciaTema(pref){
  localStorage.setItem('tema_preferencia',pref);
  localStorage.setItem('tema',resolverTemaPreferencia(pref));
  aplicarTemaResolvido();
  fecharMenuTema();
  const p=document.querySelector('.page.active')?.id?.replace('page-','');if(p)setTimeout(()=>PAGE_RENDER[p]?.(),0);
}
// Compatibilidade com chamadas antigas que passavam o tema resolvido direto.
function applyTheme(t){definirPreferenciaTema(t==='dark'?'dark':'light')}
function toggleTheme(){definirPreferenciaTema(document.documentElement.getAttribute('data-theme')==='dark'?'light':'dark')}
// Fecha os outros pop-overs do cabeçalho (conta, ações rápidas) ao abrir
// este. Sem stopPropagation() nos toggles: cada pop-over já fecha sozinho
// no clique fora (ver os listeners de 'click' no document mais abaixo); com
// stopPropagation() o clique nunca chegava até esses listeners dos OUTROS
// pop-overs, e todos ficavam abertos ao mesmo tempo (feedback do usuário).
function fecharPopoversCabecalho(exceto){
  if(exceto!=='theme')fecharMenuTema();
  if(exceto!=='conta')fecharMenuConta();
  if(exceto!=='fab')closeFab();
}
function toggleThemeMenu(event){
  const menu=document.getElementById('theme-menu'),btn=document.getElementById('theme-btn');
  if(!menu||!btn)return;
  const abrir=!menu.classList.contains('open');
  fecharPopoversCabecalho('theme');
  menu.classList.toggle('open',abrir);
  btn.setAttribute('aria-expanded',String(abrir));
}
function fecharMenuTema(){
  document.getElementById('theme-menu')?.classList.remove('open');
  document.getElementById('theme-btn')?.setAttribute('aria-expanded','false');
}
document.addEventListener('click',event=>{
  const wrap=document.getElementById('tb-theme');
  if(wrap&&!wrap.contains(event.target))fecharMenuTema();
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')fecharMenuTema()});
if(window.matchMedia){
  const _mqDark=window.matchMedia('(prefers-color-scheme: dark)');
  const _onSystemThemeChange=()=>{if(temaPreferenciaAtual()==='system')aplicarTemaResolvido()};
  if(_mqDark.addEventListener)_mqDark.addEventListener('change',_onSystemThemeChange);
  else if(_mqDark.addListener)_mqDark.addListener(_onSystemThemeChange);
}
(()=>{const t=temaInicialGaturamo();document.documentElement.setAttribute('data-theme',t)})();

